import * as ng from 'angular';
import * as _ from 'underscore';

import {Event} from './shared/event.model';
import {EventDetail} from './shared/event-detail.model';
import {ApiHelperService} from '../../shared';

export {Event, EventDetail}

export interface EventObjectApi {
   list():ng.IPromise<NamedEventObject[]>;
   add(name:string):ng.IPromise<void>;
   update(item:NamedEventObject):ng.IPromise<void>;
   del(id:number):ng.IHttpPromise<void>;
}

export interface NamedEventObject {
   id:number;
   name:string;
}

export class EventsApi {
   static $inject = ['apiHelper', 'fileDownload', 'localStorageService'];

   constructor(
      private apiHelper:ApiHelperService,
      private fileDownload,
      private localStorageService
   ) { }

   list(params:{}):ng.IPromise<{total:number,list:Event[]}> {
      return this.apiHelper.get('events', params);
   }

   get(eventId:number):ng.IPromise<EventDetail> {
      return this.apiHelper.get('events/' + eventId);
   }

   create(dto, force?:boolean) {
      let url = 'events';

      if (force) {
         url += '?force=true';
      }

      return this.apiHelper.post(url, dto);
   }

   update(dto, force?:boolean) {
      let url = 'events/' + dto.id;
      if (force) {
         url += "?force=true";
      }
      return this.apiHelper.post(url, dto);
   }

   del(eventId:number|number[], force?:boolean) {
      let url = 'events/';

      if (ng.isArray(eventId)) {
         url = url + 'bulk?ids=' + eventId.join('&ids=') + '&force=' + !!force;
      } else {
         url = url + eventId + '?force=' + !!force;
      }

      return this.apiHelper.del(url);
   }

   getEventObjectApi(resource:string, foreignId:number):EventObjectApi {
      let foreignKey = 'brandId';
      if (resource == 'partners' || resource == 'modules') {
         foreignKey = 'campaignId';
      } else if (resource == 'prizeStations') {
         foreignKey = 'eventId';
      }

      let apiHelper = this.apiHelper;

      return {
         list: function () {
            let params = {};
            params[foreignKey] = foreignId;
            return apiHelper.get(resource, params);
         },
         add: function (name) {
            let item = {Name: name};
            item[foreignKey] = foreignId;
            return apiHelper.post(resource, item);
         },
         update: function (item) {
            return apiHelper.post(`${resource}/${item.id}`, item);
         },
         del: function (id) {
            return apiHelper.del(`${resource}/${id}`);
         }
      };
   }

   download(args:{}):ng.IPromise<void> {
      return new this.fileDownload(this.apiHelper.getApiUrl(`export/event`), args).get();
   }
}

ng.module('e360')
   .service('eventsApi', EventsApi);
